export default "__VITE_ASSET__DciMrQH9__"